
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preview/profiles/[...slug]",
      function () {
        return require("private-next-pages/preview/profiles/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preview/profiles/[...slug]"])
      });
    }
  